import React from "react";

import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";

const ContactsPage = () => {
  return (
    <>
      <div className="description">
        <p style={{ fontWeight: "bold", fontSize: "32px" }}>
          Disponibile per lezioni tecnico teoriche sulla storia della batteria.
        </p>
        <div>
          <p
            style={{ fontSize: "28px", fontWeight: "bold", marginTop: "15px" }}
          >
            Per lezioni, seminari, masterclass... Contattatemi!
          </p>
          <p style={{ fontSize: "24px", marginTop: "15px" }}>
            info@millyfanzaga.com
          </p>
          <p style={{ fontSize: "24px" }}>Tel. +39 393 26 89 311</p>
          <a
            href={"https://www.instagram.com/fanzagam/"}
            style={{ textDecoration: "none" }}
          >
            <p
              style={{
                fontSize: "24px",
                marginTop: "10px",
                color: "#dd2a7b",
              }}
            >
              <InstagramIcon
                style={{ verticalAlign: "middle", marginRight: "2px" }}
              />{" "}
              fanzagam
            </p>
          </a>
          <a
            href={"https://www.facebook.com/milly.fanzaga"}
            style={{ textDecoration: "none" }}
          >
            <p style={{ fontSize: "24px", color: "#4676ee" }}>
              <FacebookIcon
                style={{ verticalAlign: "middle", marginRight: "2px" }}
              />{" "}
              Milly Fanzaga
            </p>
          </a>
        </div>
      </div>
    </>
  );
};

export default ContactsPage;
